import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'

//import './ClimeDoc.css'

const ClimeDocUI = ({ context, bucketList,
  onGetObjects, gettingObjects, selectedBucket,
  onCollapseAll, onExpandeAll, onObjectClick, onDownloadClick
}) =>
  <div className='su_doc'>
    {
      bucketList.filter(b => !b.bucketName.includes('climefinance.com')).map((bucket, i) =>
        <CardUI key={i} title={bucket.bucketName} className='g_m_bottom_100'>
          {
            !bucket.object &&
            <LinkWithSpinnerUI className='g_m_left_100' label='Get files' spinnerOnLeft={false}
              onClick={onGetObjects} busy={selectedBucket === bucket.bucketName && gettingObjects}
              rowId={bucket.bucketName}
            />
          }
          {
            bucket.object &&
            <TreeNodeUI node={bucket.object} bucketName={bucket.bucketName}
              onCollapseAll={onCollapseAll} onExpandeAll={onExpandeAll}
              onObjectClick={onObjectClick} onDownloadClick={onDownloadClick}
            />
          }
        </CardUI>
      )
    }
  </div>

const TreeNodeUI = ({ node, bucketName, onCollapseAll, onExpandeAll, onObjectClick, onDownloadClick }) =>
  <div>
    {
      node.fileName === 'root' &&
      <div className='g_flex_h g_flex_left'>
        <LinkWithSpinnerUI className='g_m_left_100' label='Collapse all'
          onClick={onCollapseAll} rowId={bucketName} />
        <LinkWithSpinnerUI className='g_m_left_100' label='Expand all'
          onClick={onExpandeAll} rowId={bucketName} />
      </div>
    }
    {
      node.fileName !== 'root' &&
      <>
        {
          node.children && node.children.length > 0 &&
          <LinkWithSpinnerUI className='g_m_left_100' label={node.fileName}
            onClick={onObjectClick} rowId={`${bucketName}:${node.fileId}`} />
        }
        {
          node.children && node.children.length == 0 &&
          <LinkWithSpinnerUI className='g_m_left_100' label={node.fileName}
            onClick={onDownloadClick} rowId={`${bucketName}:${node.fileId}`} />
        }
      </>

    }
    {
      node.children && node.children.length > 0 && !node.hide &&
      <ul>
        {
          node.children.map(childNode => (
            <li key={childNode.fileId}>
              <TreeNodeUI node={childNode} onObjectClick={onObjectClick}
                bucketName={bucketName} onDownloadClick={onDownloadClick}
              />
            </li>
          ))
        }
      </ul>
    }
  </div>

export default ClimeDocUI
